module.exports = __webpack_public_path__ + "fonts/landing-banner-in-signup.png!static";